import React from "react";
import { Col, Row, Panel } from "react-bootstrap";
import "./style.css";

const AccountManagerSearch = (props) => {
  const doSearch = (e) => {
    if (e.key === "Enter") {
      props.onSearch();
    }
  };

  return (
    <Row>
      <Col md={12}>
        <Panel className="mg-tb-20">
          <div className="fluid">
            <input
              onChange={props.onChange}
              onKeyPress={doSearch}
              placeholder="Search by ID, Account manager code or email"
              className="form-control"
              value={props.searchValue}
            />
          </div>
          <div className="fluid text-right search-button">
            <button
              className="btn red-ghost-btn mg-10"
              onClick={props.onSearch}
            >
              Search
            </button>
            <button className="btn red-ghost-btn mg-10" onClick={props.onClear}>
              Clear Search
            </button>
          </div>
        </Panel>
      </Col>
    </Row>
  );
};

export default AccountManagerSearch;



// WEBPACK FOOTER //
// ./src/components/admin/ho-accounts/account-managers/list/search.jsx